import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import TextEditor from 'flarum/common/components/TextEditor';
import ComposerPreview from './ComposerPreview';
import app from 'flarum/forum/app';
export default class Composer extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.composer = this.attrs.composer;
    this.loading = false;
    this.previewContent = false;
    this.composer.fields.content(this.attrs.originalContent || '');
  }
  view() {
    const content = this.composer.fields.content();
    const hasContent = Boolean(content);
    const loading = this.loading || this.attrs.disabled;
    return m("div", {
      className: "Flarum-Blog-Composer ".concat(loading ? 'Flarum-Blog-Composer-Loading' : '')
    }, m("div", {
      className: "Flarum-Blog-Composer-tabs"
    }, m(Button, {
      className: !this.previewContent ? 'AricleComposerButtonSelected' : '',
      onclick: () => this.previewContent = false
    }, app.translator.trans('v17development-flarum-blog.forum.composer.write')), m(Button, {
      className: this.previewContent ? 'AricleComposerButtonSelected' : '',
      onclick: () => this.previewContent = true
    }, app.translator.trans('v17development-flarum-blog.forum.composer.view'))), m("div", {
      className: "Composer Flarum-Blog-Composer-body ".concat(this.previewContent ? 'Flarum-Blog-Composer-HideEditor' : '')
    }, this.previewContent && m("div", {
      className: "Flarum-Blog-Composer-preview"
    }, !hasContent && app.translator.trans('v17development-flarum-blog.forum.composer.nothing_to_preview'), m(ComposerPreview, {
      content: content
    })), m(TextEditor, {
      submitLabel: this.attrs.submitLabel || app.translator.trans('core.forum.composer_edit.submit_button'),
      placeholder: this.attrs.placeholder,
      disabled: loading,
      composer: this.composer,
      onchange: this.composer.fields.content,
      onsubmit: this.onsubmit.bind(this),
      value: content
    })));
  }
  onsubmit() {
    var _this$attrs$onsubmit, _this$attrs;
    (_this$attrs$onsubmit = (_this$attrs = this.attrs).onsubmit) == null || _this$attrs$onsubmit.call(_this$attrs);
  }
}
flarum.reg.add('v17development-blog', 'forum/components/Composer/Composer', Composer);